import axios from "./Interceptors";
import { TCF_URL } from "./URLs";

const getAllCountries = async () => {
    return await axios.get(TCF_URL.GET_ALL_COUTRIES)
}

const getCitiesByCountry = async (countryId) => {
    return await axios.get(TCF_URL.GET_CITIES_BY_COUNTRY_ID(countryId))
}

const getCountryStates = async (countryId) => {
    return await axios.get(TCF_URL.GET_COUNTRY_STATES(countryId))
}

const fetchAllCurrencies = async () => {
    return axios.get(TCF_URL.GET_ALL_CURRENCIES)
}

const chequeAllowedCountry = async (donorCountry, currencyCountry) => {
    return await axios.get(TCF_URL.COUNTRY_ALLOWED_FOR_CHEQUE(donorCountry, currencyCountry))
}

const giftAidCountryCheck = async (payload) => {
    return await axios.post(TCF_URL.GIFT_AID_COUNTRY_CHECK, payload)
}

const corporateMatchCountryCheck = async (payload) => {
    return await axios.post(TCF_URL.CORPORATE_MATCH_COUNTRY_CHECK, payload)
}

const countryActiveForFundraiserCheck = async (countryId) => {
    return await axios.get(TCF_URL.IS_COUNTRY_ACTIVE_FOR_FUNDRAISER(countryId))
}

const countryActiveForDonorCheck = async (countryId) => {
    return await axios.get(TCF_URL.IS_COUNTRY_ACTIVE_FOR_DONOR(countryId))
}

const getBanksList = async (payload) => {
    return await axios.post(TCF_URL.GET_BANKS_LIST, payload)
}

const getCurrencyAmountChoices = async (payload) => {
    return await axios.post(TCF_URL.GET_CURRENCY_AMOUNT_CHOICES, payload)
}

const getCountriesWithoutPartners = async () => {
    return await axios.get(TCF_URL.COUNTRIES_WITHOUT_PARTNERS)
}

const getCountriesWithCurrencies = async () => {
    return await axios.get(TCF_URL.COUNTRIES_WITH_CURRENCIES)
}

const getTaxDonationMessgaes = async (countryId) => {
    return await axios.get(TCF_URL.TAX_DONATION_MESSAGES(countryId))
}

export const countriesAPIs = {
    getAllCountries,
    getCitiesByCountry,
    getCountryStates,
    fetchAllCurrencies,
    chequeAllowedCountry,
    giftAidCountryCheck,
    corporateMatchCountryCheck,
    countryActiveForFundraiserCheck,
    countryActiveForDonorCheck,
    getBanksList,
    getCurrencyAmountChoices,
    getCountriesWithoutPartners,
    getCountriesWithCurrencies,
    getTaxDonationMessgaes
}
